import odata from 'odata-client';
import {
    GET_ORGANISATIONS_REQUEST,
    GET_ORGANISATIONS_ERROR,
    GET_ORGANISATIONS_SUCCESS,
    TOKEN_EXPIRED
} from '../types';
import { getServiceUrl, getDefaultHeader } from '../../utils';
import RESOURCES from '../../api/resources';
import { showNotification } from '../notification';
/*import getToken from '../user/getToken';*/

export const tokenExpired = () => ({
    type: TOKEN_EXPIRED
});

export const getOrganisationsRequest = () => ({
    type: GET_ORGANISATIONS_REQUEST,
});

export const getOrganisationsError = errorOrResults => ({
    type: GET_ORGANISATIONS_ERROR,
    error: errorOrResults.message,
});

export const getOrganisationsSuccess = payload => ({
    type: GET_ORGANISATIONS_SUCCESS,
    payload,
});

export default () => async (dispatch, getState) => {
    /*const authorizationHeader = getToken();*/
    dispatch(getOrganisationsRequest())

    const query = odata({service: getServiceUrl()}).resource(RESOURCES.Organisations);
    query.filter("not IsDeleted");
    query.orderby("Left");
    const errorOrResult = await query.get({
        headers: {
            Authorization: `Bearer ${getState().user.token}`,
            ...getDefaultHeader()
        }
    })
        .then(resp => resp)
        .then(res => {
            const ok = res.statusCode <= 299 && res.statusCode >= 200;

            if (res.statusCode === 500) {
                const errorKey = "GENERAL_SERVER_ERROR";
                return new Error(errorKey);
            } else if (!ok) {
                console.log('update organisations api error', res.toJSON());
                const body = JSON.parse(res.body);
                const { Error: { Message } } = body
                const errorKey = res.statusCode === 401 ? `401: ${Message}` : `${Message}`;
                return new Error(errorKey);
            } else {
                const body = JSON.parse(res.body);
                const payload = body.value;
                const storeState = getState()
                if (storeState.organisation.dataIsObject) {
                    const organisationsById = {}
                    payload.forEach(obj => {
                        organisationsById[obj.ID] = obj
                    })
                    return organisationsById;
                }

                return payload
            }
        })
        .catch((error) => {
            console.error('Error:', error);
            dispatch(showNotification("Request probably timed out.", "error"))
        })

    if (errorOrResult instanceof Error) {
        dispatch(getOrganisationsError(errorOrResult, GET_ORGANISATIONS_ERROR));
        if (errorOrResult.message.split(":")[0] === "401") {
            dispatch(tokenExpired());
            dispatch(showNotification(errorOrResult.message.split(":")[1], "error"))
        }
        console.log("CODE ERROR: ", errorOrResult.message);
        dispatch(showNotification(errorOrResult.message, "error"))
        return;
    }

    dispatch(getOrganisationsSuccess(errorOrResult));
};